package com.karyadina.model

import kotlinx.serialization.Serializable

/**
 * Represents a selected image for processing
 */
@Serializable
data class ImageItem(
    val id: String,
    val name: String,
    val uri: String,
    val sizeInBytes: Long,
    val mimeType: String = "image/*",
    val width: Int = 0,
    val height: Int = 0
) {
    val sizeInKB: Double
        get() = sizeInBytes / 1024.0
    
    val sizeInMB: Double
        get() = sizeInKB / 1024.0
}

/**
 * PDF page size options
 */
enum class PdfPageSize(val displayName: String, val widthPx: Int, val heightPx: Int) {
    A4("A4 (210 x 297 mm)", 595, 842),
    A5("A5 (148 x 210 mm)", 420, 595),
    LETTER("Letter (8.5 x 11 in)", 612, 792),
    LEGAL("Legal (8.5 x 14 in)", 612, 1008),
    CUSTOM("Custom Size", 595, 842)
}

/**
 * PDF orientation
 */
enum class PdfOrientation {
    PORTRAIT,
    LANDSCAPE
}

/**
 * PDF configuration for image to PDF conversion
 */
@Serializable
data class PdfConfig(
    val pageSize: String = PdfPageSize.A4.name,
    val orientation: String = PdfOrientation.PORTRAIT.name,
    val quality: Int = 85, // JPEG quality 0-100
    val maxSizeKB: Int? = null, // Target size in KB (e.g., 500KB, 2000KB)
    val margin: Int = 20, // Margin in pixels
    val includeMetadata: Boolean = true
)

/**
 * Result of PDF conversion
 */
data class PdfConversionResult(
    val success: Boolean,
    val filePath: String? = null,
    val fileName: String? = null,
    val sizeInBytes: Long = 0,
    val pageCount: Int = 0,
    val error: String? = null
) {
    val sizeInKB: Double
        get() = sizeInBytes / 1024.0
    
    val sizeInMB: Double
        get() = sizeInKB / 1024.0
}
